import React, { Component } from 'react';
import './Widget.css';

import Overlay from '../ui/Overlay.js';

class Widget extends Component {

  render() {

    return (
      <div className = "App">
        <Overlay view = {this.props.view}/>
      </div>
    );

  }

}

export default Widget;



// WEBPACK FOOTER //
// ./src/comps/Widget.js